import React from 'react';
import NavLinks from './NavLinks';
import './style.css';

const Navegation = () => {
  return (
    <>
      <nav className="Navigation">
        <NavLinks />
      </nav>
    </>
  );
};

export default Navegation;
